import { observer } from "mobx-react-lite";

import { Stack } from "@bps/fluent-ui";

import { useNavLinks } from "./hooks/useNavLinks.ts";
import { MainMenuItem } from "./MainMenuItem.tsx";

export const MainMenu = observer(() => {
  const navLinks = useNavLinks();

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 16 }}>
      {navLinks.map((navLink, index) => (
        <MainMenuItem
          key={navLink.key || navLink.name}
          navLink={navLink}
          index={index}
        />
      ))}
    </Stack>
  );
});
